module.exports = __webpack_public_path__ + "static/media/cover4.04254933.jpg";